import { render, staticRenderFns } from "./TeachTeam.vue?vue&type=template&id=86cf6978&scoped=true&"
import script from "./TeachTeam.vue?vue&type=script&lang=js&"
export * from "./TeachTeam.vue?vue&type=script&lang=js&"
import style0 from "./TeachTeam.vue?vue&type=style&index=0&id=86cf6978&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86cf6978",
  null
  
)

export default component.exports